import React from "react";

import Button from "../../../../components/Field/Button";

import style from "../style.module.css";

export default function Congratulations() {
    return (
        <div className={style.congratulations}>
            <div className={style.form}>
                <div className={style.formRow}>
                    <div className={`${style.formRow} ${style.formSubmit}`}>
                        <Button size="buttonFullWidth" label="BROWSE WW2HQ" onClick={() => { window.location.reload() }}  />
                    </div>
                </div>
            </div>
        </div>
    )
}